import { render, staticRenderFns } from "./search-project.vue?vue&type=template&id=918489d4&"
import script from "./search-project.vue?vue&type=script&lang=js&"
export * from "./search-project.vue?vue&type=script&lang=js&"
import style0 from "./search-project.vue?vue&type=style&index=0&id=918489d4&prod&lang=less&module=true&"
import style1 from "./search-project.vue?vue&type=style&index=1&id=918489d4&prod&lang=less&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports